import { createSlice } from '@reduxjs/toolkit';

export enum ConnectionStatus {
  Idle = 'idle',
  Connecting = 'connecting',
  Connected = 'connected',
  Disconnected = 'disconnected',
  Failed = 'failed',
}

export enum RegistrationStatus {
  Idle = 'idle',
  Registering = 'registering',
  Registered = 'registered',
  Unregistered = 'unregistered',
  Failed = 'failed',
}

export interface SipConnectionState {
  connectionStatus: ConnectionStatus;
  registrationStatus: RegistrationStatus;
  registrationWanted: boolean;
}

export const initialSipConnectionState: SipConnectionState = {
  connectionStatus: ConnectionStatus.Idle,
  registrationStatus: RegistrationStatus.Idle,
  registrationWanted: false,
};

export const sipConnectionSlice = createSlice({
  name: 'sipConnection',
  initialState: initialSipConnectionState,
  reducers: {
    // Intent
    sipRegistrationWanted: (state) => {
      state.registrationWanted = true;
    },
    sipRegistrationNotWanted: (state) => {
      state.registrationWanted = false;
    },

    // Connection lifecycle (JsSIP-driven)
    sipConnectionConnecting: (state) => {
      state.connectionStatus = ConnectionStatus.Connecting;
    },
    sipConnectionConnected: (state) => {
      state.connectionStatus = ConnectionStatus.Connected;
    },
    sipConnectionDisconnected: (state) => {
      state.connectionStatus = ConnectionStatus.Disconnected;
    },
    // Registration lifecycle (JsSIP-driven)
    sipRegistrationRegistering: (state) => {
      state.registrationStatus = RegistrationStatus.Registering;
    },
    sipRegistrationRegistered: (state) => {
      state.registrationStatus = RegistrationStatus.Registered;
    },
    sipRegistrationUnregistered: (state) => {
      state.registrationStatus = RegistrationStatus.Unregistered;
    },
    sipRegistrationFailed: (state) => {
      state.registrationStatus = RegistrationStatus.Failed;
    },

    // Cleanup
    resetSipConnection: () => initialSipConnectionState,
  },
});

export const {
  sipRegistrationWanted,
  sipRegistrationNotWanted,
  sipConnectionConnecting,
  sipConnectionConnected,
  sipConnectionDisconnected,
  sipRegistrationRegistering,
  sipRegistrationRegistered,
  sipRegistrationUnregistered,
  sipRegistrationFailed,
  resetSipConnection,
} = sipConnectionSlice.actions;

export const sipConnectionReducer = sipConnectionSlice.reducer;
export default sipConnectionSlice.reducer;
